// Mock data para Industria 4.0 Landing Page

export const services = [
  {
    id: 1,
    title: 'Big Data',
    description: 'Transformamos datos masivos en insights accionables para impulsar decisiones estratégicas.',
    icon: 'database'
  },
  {
    id: 2,
    title: 'Machine Learning',
    description: 'Desarrollamos modelos de IA personalizados que aprenden y se adaptan a tus necesidades de negocio.',
    icon: 'brain'
  },
  {
    id: 3,
    title: 'Blockchain',
    description: 'Implementamos soluciones blockchain seguras y transparentes para tus operaciones.',
    icon: 'blocks'
  },
  {
    id: 4,
    title: 'Impresión 3D',
    description: 'Prototipado rápido y fabricación aditiva para optimizar tu cadena de producción.',
    icon: 'box'
  },
  {
    id: 5,
    title: 'Ciberseguridad',
    description: 'Protección integral contra amenazas digitales con sistemas avanzados de defensa.',
    icon: 'shield'
  },
  {
    id: 6,
    title: 'Desarrollo de Apps',
    description: 'Aplicaciones móviles y web escalables diseñadas para transformar tu negocio digital.',
    icon: 'smartphone'
  },
  {
    id: 7,
    title: 'IoT',
    description: 'Conecta dispositivos inteligentes y automatiza procesos para la fábrica del futuro.',
    icon: 'network'
  }
];

export const useCases = [
  {
    id: 1,
    title: 'Fabricación Inteligente',
    description: 'Integración de IoT, ML y Big Data para optimizar líneas de producción en tiempo real.'
  },
  {
    id: 2,
    title: 'Supply Chain Digital',
    description: 'Trazabilidad blockchain y análisis predictivo para cadenas de suministro resilientes.'
  },
  {
    id: 3,
    title: 'Mantenimiento Predictivo',
    description: 'Machine Learning aplicado a datos de sensores para prevenir fallos y reducir costos.'
  }
];

export const handleContactSubmit = (formData) => {
  console.log('Formulario enviado (Mock):', formData);
  return {
    success: true,
    message: 'Solicitud enviada correctamente. Te contactaremos pronto.'
  };
};